import { render, staticRenderFns } from "./DocumentPart.vue?vue&type=template&id=4d0a69b7&scoped=true"
import script from "./DocumentPart.vue?vue&type=script&lang=js"
export * from "./DocumentPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a69b7",
  null
  
)

export default component.exports